import pino from 'pino';

/**
 * Logger instance for the Order@ISS Outlook add-in.
 * Configured for browser environment.
 *
 * - Development: debug level, structured JSON to browser console
 * - Production: info level only, minimal overhead
 */
const logger = pino({
  level: import.meta.env.MODE === 'production' ? 'info' : 'debug',
});

/**
 * Create a child logger with a specific module name.
 * Usage: const log = createModuleLogger('MeetingReader');
 *
 * Child loggers inherit the parent's level while adding module context
 * Example output:
 *   {"level":30,"time":1689...,"module":"MeetingReader","msg":"User domain extracted"}
 */
export function createModuleLogger(moduleName: string) {
  return logger.child({ module: moduleName });
}

export default logger;
